import React, { forwardRef } from "react";
import manufacturingImg from "../../assets/manufacturenew.png";
import { Link } from "react-router-dom";

const Manufacture = forwardRef((props, ref) => {
  return (
    <>
 <section
  ref={ref}
  style={{
    position: "relative",
    width: "100%",
    height: "660px",
    overflow: "hidden",
  }}
>
        <img
          src={manufacturingImg}
          alt="Manufacturing ERP"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: "1",
          }}
        />

        <div
          style={{
            position: "relative",
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 60px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ maxWidth: "550px", zIndex: 2 }}>
            <h1
              style={{
                fontSize: "42px",
                fontWeight: "700",
                marginBottom: "24px",
                marginTop: "24px",
                color: "#fff",
                lineHeight: "1.2",
              }}
            >
              Smart Manufacturing ERP
              for Complete Factory Control
            </h1>
 <p
          style={{
            fontSize: "18px",
            marginBottom: "30px",
            lineHeight: "1.6",
            color: "#fff",
            textAlign: "left",
          }}
        >
          Plan production, manage inventory, track orders, control costing and
          monitor accounts – all-in-one integrated ERP platform designed for
          manufacturers.
        </p>

            <div style={{ display: "flex", gap: "16px" }}>
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <button
                  style={{
                    backgroundColor: "#10b981",
                    color: "#fff",
                    padding: "14px 32px",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "16px",
                    transition: "all 0.3s",
                  }}
                >
                  Request Demo
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT SECTION */}
      <section
        style={{
          background: "linear-gradient(to bottom, #e8f1ff, #dce9ff)",
          padding: "40px 30px",
        }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* Manufacturing Challenges */}
          <h2 style={headingStyle}>Manufacturing Challenges We Solve</h2>

          <p style={subHeadingStyle}>
            Plan production, manage inventory track orders
          </p>

          <div style={challengesGridStyle}>
            {[
              {
                title: "Manual production planning",
                icon: "📋",
              },
              {
                title: "Stock mismatch & material shortages",
                icon: "📦",
              },
              {
                title: "Delayed purchase decisions",
                icon: "🔔",
              },
              {
                title: "Job work tracking difficulty",
                icon: "📊",
              },
              {
                title: "Costing inaccuracies",
                icon: "💰",
              },
            ].map((item, index) => (
              <div key={index} style={challengeCardStyle}>
                <div style={iconContainerStyle}>{item.icon}</div>
                <p style={challengeTextStyle}>{item.title}</p>
              </div>
            ))}
          </div>

          <p style={taglineStyle}>
            AccessONE ERP connects your entire factory on{" "}
            <strong>one system.</strong>
          </p>

          {/* Key Modules */}
          <h2 style={{ ...headingStyle, marginTop: "10px" }}>Key Modules</h2>

          <p style={subHeadingStyle}>
            Plan production, manage inventory track orders
          </p>

          <div style={modulesGridStyle}>
            <div style={moduleCardStyle}>
              <div style={moduleIconStyle}>📋</div>
              <h4 style={moduleHeadingStyle}>Manual production planning</h4>
              <ul style={moduleListStyle}>
                <li>✓ BOM & Routing</li>
                <li>✓ Production Planning</li>
                <li>✓ Work Order Management</li>
                <li>✓ Job Work Tracking</li>
              </ul>
            </div>

            <div style={moduleCardStyle}>
              <div style={moduleIconStyle}>📝</div>
              <h4 style={moduleHeadingStyle}>Purchase Management</h4>
              <ul style={moduleListStyle}>
                <li>✓ Material Requirement</li>
                <li>✓ Vendor Management</li>
                <li>✓ Purchase Orders</li>
                <li>✓ GRN Tracking</li>
              </ul>
            </div>

            <div style={moduleCardStyle}>
              <div style={moduleIconStyle}>🏭</div>
              <h4 style={moduleHeadingStyle}>Warehouse & Inventory</h4>
              <ul style={moduleListStyle}>
                <li>✓ Batch / Lot Tracking</li>
                <li>✓ Multi-godown support</li>
                <li>✓ Reorder alerts</li>
                <li>✓ Customer Order Status</li>
              </ul>
            </div>

            <div style={moduleCardStyle}>
              <div style={moduleIconStyle}>🚚</div>
              <h4 style={moduleHeadingStyle}>Sales & Dispatch</h4>
              <ul style={moduleListStyle}>
                <li>✓ Sales Orders</li>
                <li>✓ Dispatch Planning</li>
                <li>✓ Delivery Tracking</li>
                <li>✓ Customer Order Status</li>
              </ul>
            </div>

            <div style={moduleCardStyle}>
              <div style={moduleIconStyle}>💰</div>
              <h4 style={moduleHeadingStyle}>Accounts & Finance</h4>
              <ul style={moduleListStyle}>
                <li>✓ GST compliant accounting</li>
                <li>✓ Receivable & Payable tracking</li>
                <li>✓ Cost center accounting</li>
                <li>✓ Profitability reports</li>
              </ul>
            </div>
          </div>
          {/* Benefits Section */}
          <div style={benefitsSectionStyle}>
            <div style={benefitsColumnStyle}>
              <h3 style={benefitsHeadingStyle}>Benefits</h3>
              <ul style={benefitsListStyle}>
                <li>✓ Real-time production visibility</li>
                <li>✓ Reduced inventory loss</li>
                <li>✓ Faster decision making</li>
                <li>✓ Accurate costing & margins</li>
                <li>✓ Improved delivery commitment</li>
              </ul>
            </div>

            <div style={benefitsColumnStyle}>
              <h3 style={benefitsHeadingStyle}>Why Choose AccessONE ERP</h3>
              <ul style={benefitsListStyle}>
                <li>✓ 25+ years industry expertise</li>
                <li>✓ Customizable for indian manufacturing</li>
                <li>✓ Cloud & On-Premise available</li>
                <li>✓ Dedicated training & support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
});

/* STYLES */
const headingStyle = {
  textAlign: "center",
  fontSize: "42px",
  fontWeight: "700",
  marginBottom: "16px",
  color: "#1a2847",
  fontFamily: "system-ui, -apple-system, sans-serif",
};

const subHeadingStyle = {
  textAlign: "center",
  marginBottom: "10px",
  color: "#64748b",
  fontSize: "20px",
  fontWeight: "500",
};

const challengesGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: "24px",
  marginBottom: "50px",
};

const challengeCardStyle = {
  background: "rgba(255,255,255,0.7)",
  padding: "32px 20px",
  borderRadius: "16px",
  textAlign: "center",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  transition: "transform 0.3s",
};

const iconContainerStyle = {
  fontSize: "48px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "80px",
};

const challengeTextStyle = {
  fontSize: "15px",
  fontWeight: "600",
  color: "#1a2847",
  margin: 0,
  lineHeight: "1.4",
};

const taglineStyle = {
  textAlign: "center",
  fontSize: "20px",
  color: "#1a2847",
  marginTop: "10px",
  fontWeight: "500",
};

const modulesGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: "24px",
  marginBottom: "50px",
};

const moduleCardStyle = {
  background: "rgba(255,255,255,0.7)",
  padding: "32px 24px",
  borderRadius: "16px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  textAlign: "center",
};

const moduleIconStyle = {
  fontSize: "48px",
  marginBottom: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "80px",
};

const moduleHeadingStyle = {
  fontSize: "16px",
  fontWeight: "700",
  color: "#1a2847",
  marginBottom: "20px",
  minHeight: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const moduleListStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  textAlign: "left",
  fontSize: "14px",
  color: "#475569",
  lineHeight: "2",
};

const benefitsSectionStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "80px",
  marginTop: "20px",
};

const benefitsColumnStyle = {
  background: "rgba(255,255,255,0.5)",
  padding: "40px",
  borderRadius: "16px",
};

const benefitsHeadingStyle = {
  fontSize: "28px",
  fontWeight: "700",
  color: "#1a2847",
  marginBottom: "24px",
};

const benefitsListStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  fontSize: "16px",
  color: "#475569",
  lineHeight: "2.2",
};

export default Manufacture;